/* ---------------------------------
GLOBAL FUNCTIONS
---------------------------------*/

//Hace lo mismo que getPriceFromNumber pero los últimos 2 números son decimales. Sirve para actualizar el carrito.
function getPriceFromNumberWithDecimals(value, type = "default") {
  // Convertir el número en string para separar los decimales

  let stringValue = value.toString();

  // Tomar los últimos dos dígitos como decimales
  let integerPart = stringValue.slice(0, -2);
  let decimalPart = stringValue.slice(-2);

  // Si la parte entera es vacía, asumir que es 0
  integerPart = integerPart || "0";

  // Agregar separadores de miles (puntos) a la parte entera
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  // Si el tipo es default, añadir el símbolo de $
  return type === "default" ? `$${integerPart}` : integerPart;
}

//Hace fetch al carrito
createCartPromise = () =>
  new Promise(async (t) => {
    t(await (await fetch(`${Shopify.routes.root}cart.js`)).json());
  });

/* ---------------------------------
TOGGLE BTN
---------------------------------*/

class ToggleBtn extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    const button = document.createElement("button");
    button.id = "toggle-btn";
    button.style.backgroundColor = "transparent";
    button.style.border = "0px";
    button.style.cursor = "pointer";

    const slot = document.createElement("slot");
    slot.name = "toggle";
    slot.classList.appendChild = " bg-[#DA291C] border-0 cursor-pointer";

    button.appendChild(slot);
    this.shadowRoot.appendChild(button);
    this.toggleSidebar = this.toggleSidebar.bind(this);
  }

  connectedCallback() {
    this.bg = document.querySelector("#header-bg");
    this.sidebar = document.querySelector("#sidebar");
    this.toggleBtn = this.shadowRoot.querySelector("button");

    this.toggleBtn.addEventListener("click", this.toggleSidebar);
  }

  toggleSidebar() {
    const isHiddenBg = this.bg.style.visibility === "hidden";

    if (isHiddenBg) {
      this.bg.style.visibility = "visible";
      this.sidebar.style.transform = "translateX(0%)";
    } else {
      this.bg.style.visibility = "hidden";
      this.sidebar.style.transform = "translateX(100%)";
    }
  }
}

customElements.define("toggle-btn", ToggleBtn);

const sidebarBtns = document.querySelectorAll(".sidebar-item");
const bg = document.querySelector("#header-bg");
const sidebar = document.querySelector("#sidebar");

sidebarBtns.forEach((btn) => {
  btn.addEventListener("click", () => {
    const isHiddenBg = bg.style.visibility === "hidden";

    if (isHiddenBg) {
      bg.style.visibility = "visible";
      sidebar.style.transform = "translateX(0%)";
    } else {
      bg.style.visibility = "hidden";
      sidebar.style.transform = "translateX(100%)";
    }
  });
});

/* ---------------------------------
MEGA MENU
---------------------------------*/

class MegaMenu extends HTMLElement {
  constructor() {
    super();
    this.id = this.getAttribute("link");
    this.relatedLink = document.querySelector(`#header-${this.id}`);

    // Agregar eventos
    this.relatedLink.addEventListener("mouseenter", () => this.openMenu());
    this.relatedLink.addEventListener("mouseleave", () => this.closeMenu());
  }

  openMenu() {
    // Quitar clases que ocultan el mega-menu
    this.classList.remove("opacity-0", "invisible");
    // Asegurar que la transición ocurra después de quitar las clases
    this.classList.add("opacity-100");
  }

  closeMenu() {
    // Iniciar la transición de cierre
    this.classList.remove("opacity-100");
    // Después de la transición, volver a agregar la invisibilidad
    this.classList.add("opacity-0", "invisible");
  }
}

customElements.define("mega-menu", MegaMenu);

/* ---------------------------------
CART MENU
---------------------------------*/

class CartMenu extends HTMLElement {
  constructor() {
    super();
    this.toggleBtns = document.querySelectorAll(
      `.reference-${this.dataset.id}`
    );

    this.eraseBtns = this.querySelectorAll("svg");

    this.toggleStatus = this.toggleStatus.bind(this);
    this.detectOutsideClick = this.detectOutsideClick.bind(this);
    this.cartChanged = this.cartChanged.bind(this);
    this.eraseFromCart = this.eraseFromCart.bind(this);

    this.toggleBtns.forEach((btn) => {
      btn.addEventListener("click", this.toggleStatus);
    });

    this.eraseBtns.forEach((it) => {
      it.addEventListener("click", () => this.eraseFromCart(it));
    });

    document.addEventListener("cart:change", this.cartChanged);
  }

  toggleStatus() {
    const status = this.getAttribute("status");
    if (status === "close") {
      this.setAttribute("status", "open");
    } else {
      this.setAttribute("status", "close");
    }
  }

  static get observedAttributes() {
    return ["status"];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "status") {
      if (newValue === "open") {
        this.classList.remove("hidden");
        setTimeout(() => {
          this.classList.add("show");
        }, 50);
        document.addEventListener("click", this.detectOutsideClick);
      } else if (newValue === "close") {
        this.classList.remove("show");
        setTimeout(() => {
          this.classList.add("hidden");
        }, 50);
        document.removeEventListener("click", this.detectOutsideClick);
      }
    }
  }

  detectOutsideClick = (e) => {
    // Obtiene la posición X e Y donde se hizo clic
    const x = e.clientX;
    const y = e.clientY;

    // Selecciona todos los elementos en esa posición
    const elements = document.elementsFromPoint(x, y);

    // Itera sobre los elementos y haz lo que necesites con ellos
    const isCartMenuPresent = elements.some(
      (el) => el.id === `cart-menu-${this.dataset.id}`
    );
    const isBtnPresent = elements.some((el) =>
      el.classList.contains(`reference-${this.dataset.id}`)
    );

    if (!isCartMenuPresent && !isBtnPresent) {
      const status = this.getAttribute("status");
      if (status === "open") {
        this.setAttribute("status", "close");
      }
    }
  };

  eraseFromCart = async (it) => {
    const line = it.dataset.line;
    let variantId = null;
    let uid = null;
  
    // Fetch current cart
    const cartItems = await this.getCartItems();
  
    // Find the line item with the matching line number
    const currentItem = cartItems.items.find((item, index) => index + 1 == line); // Shopify line numbers start at 1

  
    if (currentItem) {
      variantId = currentItem.variant_id; // Get the variant_id of the current item
      uid = currentItem.properties && currentItem.properties.uid; // Get the UID from properties
  
      if (uid) {
        // Find all other items with the same UID
        const matchingItems = cartItems.items.filter(item => item.properties && item.properties.uid === uid);
        // Delete all matching items by line
        for (const item of matchingItems) {
          await this.deleteItemByKey(item.key); // Delete item by line number
        }
      } else {
        // Delete the item by line number
        await this.deleteItemByLine(line);
      }
      // Trigger the cart update event after removing the item
      const cart = await createCartPromise();
      this.dispatchEvent(
        new CustomEvent("cart:change", {
          bubbles: true,
          cart,
          detail: {
            cart,
          },
        })
      );
    } else {
      console.log('Item not found in the cart');
    }
  };
  
  deleteItemByLine = async (line) => {
    try {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          line: String(line),
          quantity: 0,
        }),
      });

    } catch (error) {
      console.log("Error removing item from cart:", error);
    }
  };

  deleteItemByKey = async (line) => {
    try {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          id: String(line),
          quantity: 0,
        }),
      });

    } catch (error) {
      console.log("Error removing item from cart:", error);
    }
  };
  
  getCartItems = async () => {
    try {
      const response = await fetch("/cart.js");
      if (!response.ok) throw new Error("Failed to fetch cart items");
      return await response.json();
    } catch (error) {
      console.log("Error fetching cart items:", error);
    }
  };
  

  cartChanged = (event) => {
    //Del evento que enviamos al agregar un producto (cart:change), enviamos el detail con el JSON de cart.
    const cart = event.detail.cart;
    //console.log(cart);

    //Seleccionamos los contadores (mobile y laptop) y los contenedores
    const counter = document.querySelector("#cart-header-counter");
    const mobileCounter = document.querySelector("#counter-mobile");
    const cartFullContainer = document.querySelector("#cart-header-container");
    const cartEmptyContainer = document.querySelector("#cart-empty-container");
    const itemsList = cartFullContainer.querySelector("article");

    if (cart.items.length > 0) {
      //Se actualiza el contador del carrito en laptop y mobile
      counter.innerText = `(${cart.items.length})`;
      counter.classList.remove("hidden");
      mobileCounter.innerText = cart.items.length;
      mobileCounter.classList.remove("hidden");
      //Se muestra el contenedor
      cartFullContainer.classList.remove("hidden");
      cartEmptyContainer.classList.add("hidden");
    } else {
      //Se quita el contador del carrito en laptop y mobile
      counter.classList.add("hidden");
      mobileCounter.classList.add("hidden");
      //Se oculta el contenedor
      cartFullContainer.classList.add("hidden");
      cartEmptyContainer.classList.remove("hidden");
    }

    //Creamos un <div> por cada item del carrito
    let newItems = cart.items.map((item, index) => {
      return `<div class=" rounded-lg bg-[#F6F6F6] py-2 px-5 flex justify-between gap-8 items-center">
                  <a href="${
                    item.url
                  }" class=" w-[60px] h-[70px] flex cursor-pointer">
                        <img src="${
                          item.image
                        }" class:" object-contain w-full" style="object-fit:contain;"/>
                  </a>
                  <div class=" flex flex-col gap-1 w-[200px] items-start">
                      <a href="${item.url}" 
                      class=" text-sm font-semibold transition-all duration-200 hover:underline
                    hover:text-[#da291c]">${item.product_title} ${
        !item.properties.varianteConectada ? `(${item.variant_title})` : ""
      } </a>
                      <p class=" text-xs text-[#878787] font-medium">${
                        !item.properties.varianteConectada
                          ? `${item.quantity} unds`
                          : item.variant_title
                      }</p>
                      ${
                        item.properties.imagenMarcado
                          ? ` <p class=" text-xs text-[#878787] font-medium">Logo: <a href="${item.properties.imagenMarcado}" target="_blank">${String(item.properties?.imagenMarcado).slice(0,16)}...</a></p>`
                          : ""
                      }
                      <p class=" text-xs text-[#878787] font-medium">Subtotal ${getPriceFromNumberWithDecimals(
                        item.line_price
                      )}</p>
                  </div>
                    <svg data-line=${index + 1}
                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class=" cursor-pointer  transition-all duration-200 hover:text-[#da291c]">
                        <polyline points="3 6 5 6 21 6"></polyline>
                        <path d="M19 6l-2 14H7L5 6"></path>
                        <path d="M10 11v6"></path>
                        <path d="M14 11v6"></path>
                        <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"></path>
                    </svg>
                </div>`;
    });
    itemsList.innerHTML = newItems.join("");

    //A cada boton de borrar nuevo le asignamos el evento para que se borre
    this.eraseBtns = this.querySelectorAll("svg");
    this.eraseBtns.forEach((it) => {
      it.addEventListener("click", () => this.eraseFromCart(it));
    });

    //Si openCart es true, abrimos el carrito al hacer un cambio, sino no.
    if (event.detail.openCart) {
      hideErrorMessage();
      const status = this.getAttribute("status");
      if (status === "close") {
        this.setAttribute("status", "open");
      }
    }
  };
}

customElements.define("cart-menu", CartMenu);
